import {navHeightItem} from "../../../../../../@signals";
import { dsColorNew } from "@palette";
import { alpha } from "@mui/material/styles"


export const MaximalLayoutNavVerticalItemStyles = (isActive, isSubItem, theme) => ({
    position: 'relative',
    textTransform: 'capitalize',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    color: alpha(dsColorNew.white, 0.82),
    borderRadius: theme.shape.borderRadius,
    height: navHeightItem.value,
    '&:hover': {
        backgroundColor: alpha(dsColorNew.white, 0.06),
        color: dsColorNew.white,
    },
    ...( isActive && {
        color: dsColorNew.white,
        ...( !isSubItem && {
            backgroundColor: dsColorNew.appBlue,
        }),
        '&:hover': {
            color: dsColorNew.white,
            backgroundColor: dsColorNew.appBlueHover,
        },
        i: {
            color: dsColorNew.white,
        }
    })
})

export const MaximalLayoutNavVerticalIconStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    minWidth: "auto",
    width: "24px",
    height: "24px",
    color: 'inherit'
}